import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme?.designer?.propertyBackgroundColor,
    borderRadius: theme.spacing(0.8),
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1),
    paddingLeft: theme.spacing(3),
    paddingRight: theme.spacing(3),
    marginBottom: theme.spacing(1),
  },
  formControl: {
    width: '60%',
    backgroundColor: theme?.designer?.inputBackgroundColor,
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
    paddingTop: theme.spacing(0.5),
    paddingBottom: theme.spacing(0.5),
  },
  input: {
    textAlign: 'center',
  },
  swatch: {
    border: '0.2vh solid rgb(0, 0, 0, 0.35)',
    height: '45px',
    width: '45px',
    borderRadius: theme.spacing(0.8),
  },
  popover: {
    position: 'absolute',
    zIndex: 2,
    top: '48px',
    left: '0px',
  },
  cover: {
    position: 'fixed',
    top: '0px',
    right: '0px',
    bottom: '0px',
    left: '0px',
  },
  colorTitle: {
    color: theme?.designer?.inputLabelColor,
    textTransform: 'capitalize',
  },
  colorInput: {
    color: theme?.designer?.inputTextColor,
    borderColor: theme?.designer?.inputBorderColor,
    height: '22px',
    width: '100px',
    borderWidth: '1px',
    borderStyle: 'solid',
    borderRadius: '4px',
    paddingLeft: theme.spacing(1),
    fontStyle: 'normal',
    fontWeight: 600,
    fontSize: '14px',
  },
  fillTitle: {
    color: theme?.designer?.textColor,
    marginBottom: theme.spacing(1),
  },
  shapeTitle: {
    color: theme?.designer?.textColor,
  },
  propertyNameWrapper: {
    backgroundColor: theme?.designer?.propertyBackgroundColor,
  },
  actionBtn: {
    backgroundColor: theme?.designer?.actionButtonBackgroundColor,
    borderRadius: theme.spacing(0.5),
    height: '40px',
    width: '40px',
  },
  actionIcon: {
    color: theme?.designer?.headerIconColor,
  }
}));

export default useStyles;
